"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxToggle = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = require("b2b-components/theme/components/Tooltip");
var _classnames = _interopRequireDefault(require("classnames"));
var _CheckboxInput = require("../CheckboxInput");
var _useCheckboxState = require("../useCheckboxState");
var _ = require("./");
require("./CheckboxToggle.scss");
const CheckboxToggle = _ref => {
  let {
    onChange,
    isChecked = false,
    isDefaultChecked = false,
    label,
    style = _.CHECKBOX_TOGGLE_STYLE.DEFAULT,
    tooltipContent,
    className
  } = _ref;
  const state = (0, _useCheckboxState.useCheckboxState)(isDefaultChecked, isChecked, onChange);
  const toggleWrapperClassName = (0, _classnames.default)(className, `cds-CheckboxToggle-Wrapper--${style}`, 'cds-CheckboxToggle-Wrapper', {
    'cds-CheckboxToggle-Wrapper--Checked': state.isChecked
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-CheckboxToggle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: toggleWrapperClassName
  }, /*#__PURE__*/_react.default.createElement(_CheckboxInput.CheckboxInput, {
    className: "cds-CheckboxToggle-HiddenInput",
    isChecked: state.isChecked,
    isDisabled: false,
    onChange: state.onChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-CheckboxToggle-Switch"
  })), !!label && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    contentClassName: "cds-CheckboxToggle-TooltipContent",
    content: tooltipContent
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('cds-CheckboxToggle-Label', `cds-CheckboxToggle-Label--${style}`)
  }, label)));
};
exports.CheckboxToggle = CheckboxToggle;
//# sourceMappingURL=CheckboxToggle.js.map